(() => {
  const update = () => document.querySelectorAll('.badge.onsale').forEach(el => {
    if (el.querySelector('.nn-save-value')) return;
    for (const node of Array.from(el.childNodes)) {
      if (node.nodeType !== Node.TEXT_NODE) continue;
      const match = node.textContent.match(/[-−]?\d+(?:[.,]\d+)?\s*%/);
      if (!match) continue;
      const span = document.createElement('span'); span.className = 'nn-save-value';
      span.textContent = match[0];
      node.replaceWith(document.createTextNode(node.textContent.slice(0,match.index)),span,
        document.createTextNode(node.textContent.slice(match.index+match[0].length)));
    }
  });
  let queued=false;
  new MutationObserver(()=>{if(!queued){queued=true;requestAnimationFrame(()=>{queued=false;update()})}})
    .observe(document.body,{childList:true,subtree:true,characterData:true});
  update();
})();